import React, { useState, useRef } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import FormatBoldIcon from "@mui/icons-material/FormatBold"; // Icon for bold text
import CropSquareIcon from "@mui/icons-material/CropSquare"; // Square icon
import CircleIcon from "@mui/icons-material/Circle"; // Circle icon
import ColorPicker from "./ColorPicker";
import BackgroundColorPicker from "./BackgroundColorPicker";

import "./Toolbar.css"; // Ensure you style it properly

// const googleFonts = [
//   "Roboto",
//   "Open Sans",
//   "Lobster",
//   "Montserrat",
//   "Poppins",
//   "Raleway",
//   "Playfair Display",
//   "Lora",
//   "Nunito",
//   "Merriweather",
// ];

const webSafeFonts = [
  "Arial",
  "Verdana",
  "Times New Roman",
  "Courier New",
  "Georgia",
  "Trebuchet MS",
  "Comic Sans MS",
  "Tahoma",
  "Lucida Console",
];

const Toolbar = ({
  type,
  fontSize,
  setFontSize,
  color,
  setColor,
  backgroundColor,
  setBackgroundColor,
  fontWeight,
  setFontWeight,
  fontFamily,
  setFontFamily,
  shape,
  setShape,
  onRemove,
}) => {
  const [showPicker, setShowPicker] = useState({ type: "", isShow: false }); // Toggle state for color picker

  return (
    <div
      onClick={(e) => e.stopPropagation()} // Prevent click from affecting parent
      className="toolbar-container tool-icon"
    >
      {type === "image" && (
        <>
          {/* Shape Selection Buttons */}
          <CropSquareIcon
            className="toolbar-icon tool-icon"
            onClick={() => setShape("square")}
            style={{
              // cursor: "pointer",
              color: shape === "square" ? "blue" : "#999",
              fontSize: "33px",
              // padding: "4px",
            }}
          />
          <CircleIcon
            className="toolbar-icon tool-icon"
            onClick={() => setShape("circle")}
            style={{
              // cursor: "pointer",
              color: shape === "circle" ? "blue" : "#999",
              fontSize: "30px",
              // padding: "4px",
            }}
          />
        </>
      )}

      {type === "text" && (
        <>
          {/* Font Family Selector */}
          <select
            className="tool-icon"
            value={fontFamily}
            onChange={(e) => setFontFamily(e.target.value)}
            style={{
              padding: "4px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              cursor: "pointer",
              display: "flex",
              minWidth: "120px",
            }}
          >
            {webSafeFonts.map((font) => (
              <option key={font} value={font} style={{ fontFamily: font }}>
                {font}
              </option>
            ))}
          </select>

          {/* Font Size */}
          <button
            className="tool-icon"
            onClick={() => setFontSize(Math.max(fontSize - 1, 1))}
            style={{ padding: "4px 8px", cursor: "pointer" }}
          >
            -
          </button>
          <span style={{ margin: "0 5px" }}>{fontSize}px</span>
          <button
            className="tool-icon"
            onClick={() => setFontSize(fontSize + 1)}
            style={{ padding: "4px 8px", cursor: "pointer" }}
          >
            +
          </button>

          {/* Font Weight (Bold) Icon */}
          <FormatBoldIcon
            className="bold-icon tool-icon"
            onClick={() =>
              setFontWeight(fontWeight === "bold" ? "normal" : "bold")
            }
            style={{
              cursor: "pointer",
              color: fontWeight === "bold" ? "#000" : "#999191", // Change color based on fontWeight
              fontSize: "30px",
              padding: "4px",
              marginRight: "-4px",
            }}
          />

          {/* Font Color Picker with Icon */}
          <ColorPicker
            color={color}
            setColor={setColor}
            showPicker={showPicker}
            setShowPicker={setShowPicker}
          />

          {/* Background Color Picker with Icon */}
          <BackgroundColorPicker
            backgroundColor={backgroundColor}
            setBackgroundColor={setBackgroundColor}
            showPicker={showPicker}
            setShowPicker={setShowPicker}
          />
        </>
      )}

      {/* Delete Button */}
      <DeleteIcon
        className="trash-icon toolbar-icon tool-icon"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      />
    </div>
  );
};

export default Toolbar;
